// Compone el texto localizado de un insight a partir de { code, severity,
// evidence } que manda el backend (sin texto). El backend manda porcentajes
// como fracción 0..1 → acá se formatean a %. Code desconocido → fallback
// genérico, nunca rompe.
//
// Usa la instancia i18n del repo y llama i18n.t(...) como MÉTODO (this preservado).
// Patrón canónico de helpers/services (ej. errors/toastError.js). NO recibir `t`
// suelto: i18n.t desacoplado pierde `this` → "Cannot read 'translator' of undefined".

import { i18n } from "../translate/i18n";

const PCT_KEYS = ["pct", "fueraHorarioPct", "sinRespuestaWarnPct"];

const formatEvidence = (evidence = {}) => {
  const out = { ...evidence };
  PCT_KEYS.forEach((k) => {
    if (typeof out[k] === "number") {
      out[k] = `${Math.round(out[k] * 100)}%`;
    }
  });
  return out;
};

const KNOWN_CODES = new Set([
  "ventana_muerta",
  "disparo_tardio",
  "timeout_absorbe",
  "reclamo_sin_atencion",
  "buena_cobertura",
]);

export const buildInsightText = (insight) => {
  if (!insight || !insight.code) return "";
  const vars = formatEvidence(insight.evidence);
  const key = KNOWN_CODES.has(insight.code)
    ? `aiAssistantStats.insights.${insight.code}`
    : "aiAssistantStats.insights.generic";
  return i18n.t(key, vars);
};

// Tono pro-Sofía (display-only): logros (success) → "Sofía en acción" verde;
// todo lo demás (warning/info) → "Oportunidad" azul constructivo.
export const severityLabel = (severity) => {
  switch (severity) {
    case "success":
      return i18n.t("aiAssistantStats.insights.severitySofiaEnAccion");
    case "warning":
    case "info":
    default:
      return i18n.t("aiAssistantStats.insights.severityOportunidad");
  }
};

export const severityColor = (severity) => {
  switch (severity) {
    case "success":
      return "#00a884"; // verde WhatsApp — Sofía en acción
    case "warning":
    case "info":
    default:
      return "#1565c0"; // azul info — Oportunidad
  }
};

// Grupo de display: 0 = "Sofía en acción" (success, verde) primero,
// 1 = "Oportunidad" (warning/info, azul) después.
const displayGroup = (severity) => (severity === "success" ? 0 : 1);

// Ordena para el display: verdes (logros) primero, luego azules. Estable
// dentro de cada grupo (preserva el orden que ya mandó el backend). No muta.
export const sortInsightsForDisplay = (insights = []) =>
  [...(insights ?? [])]
    .map((ins, idx) => ({ ins, idx }))
    .sort(
      (a, b) =>
        displayGroup(a.ins.severity) - displayGroup(b.ins.severity) ||
        a.idx - b.idx
    )
    .map((x) => x.ins);
